import { jsx as _jsx } from "react/jsx-runtime";
import { StyledEngineProvider } from "@mui/material";
import { MaterialThemeProvider } from "@vestwell-frontend/style";
import { memo } from "react";
export var ThemeProvider = /*#__PURE__*/ memo(function(props) {
    return /*#__PURE__*/ _jsx(StyledEngineProvider, {
        injectFirst: true,
        children: /*#__PURE__*/ _jsx(MaterialThemeProvider, {
            isWhitelabeled: props.isWhitelabeled,
            children: props.children
        })
    });
});
ThemeProvider.displayName = 'ThemeProvider';

//# sourceMappingURL=ThemeProvider.js.map